var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 7.5C9.33761 7.5 8.70173 7.76339 8.23288 8.23223C7.76404 8.70107 7.50065 9.33696 7.50065 10C7.50065 10.663 7.76404 11.2989 8.23288 11.7678C8.70173 12.2366 9.33761 12.5 10.0007 12.5C10.6637 12.5 11.2996 12.2366 11.7684 11.7678C12.2373 11.2989 12.5007 10.663 12.5007 10C12.5007 9.33696 12.2373 8.70107 11.7684 8.23223C11.2996 7.76339 10.6637 7.5 10.0007 7.5ZM10.0007 14.1667C8.89558 14.1667 7.83578 13.7277 7.05437 12.9463C6.27297 12.1649 5.83398 11.1051 5.83398 10C5.83398 8.89493 6.27297 7.83512 7.05437 7.05372C7.83578 6.27232 8.89558 5.83333 10.0007 5.83333C11.1057 5.83333 12.1655 6.27232 12.9469 7.05372C13.7283 7.83512 14.1673 8.89493 14.1673 10C14.1673 11.1051 13.7283 12.1649 12.9469 12.9463C12.1655 13.7277 11.1057 14.1667 10.0007 14.1667ZM10.0007 3.75C5.83398 3.75 2.27565 6.34167 0.833984 10C2.27565 13.6583 5.83398 16.25 10.0007 16.25C14.1673 16.25 17.7257 13.6583 19.1673 10C17.7257 6.34167 14.1673 3.75 10.0007 3.75Z",
    fill: "#8B8B8B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.43251,
    y1: 3.38727,
    x2: 19.2506,
    y2: 15.9647,
    stroke: "#8B8B8B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeclose);
export default __webpack_public_path__ + "static/media/eyeclose.f49a5d0ec506c5f6ee81438b6ca6d207.svg";
export { ForwardRef as ReactComponent };